import React from "react";

const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function DiagramCoordinates() {
  const W = 900, H = 340;
  const iso = (x, y, z) => [W*0.22 + (x-z)*0.866*38, H*0.72 - y*52 + (x+z)*0.5*38];
  const [ox,oy]=iso(0,0,0), [xx,xy]=iso(3.2,0,0), [yx,yy]=iso(0,3.2,0), [zx,zy]=iso(0,0,3.2);
  const [ppx,ppy]=iso(2,2,1.5), [fx,fy]=iso(2,0,1.5), [lx,ly]=iso(2,2,0), [rx,ry]=iso(0,2,1.5);
  const grid=[];
  for(let i=0;i<=3;i++){
    const [a1,a2]=iso(i,0,0),[b1,b2]=iso(i,0,3),[c1,c2]=iso(0,0,i),[d1,d2]=iso(3,0,i);
    grid.push(<line key={"x"+i} x1={a1} y1={a2} x2={b1} y2={b2} stroke="#dde8f5" strokeWidth="1"/>);
    grid.push(<line key={"z"+i} x1={c1} y1={c2} x2={d1} y2={d2} stroke="#dde8f5" strokeWidth="1"/>);
  }
  const px0=520, panW=W-px0-14;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>3D Coordinate System — Axes, Points, and Projections</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {grid}
        <line x1={ox} y1={oy} x2={xx} y2={xy} stroke="#2E75B6" strokeWidth="2.2"/>
        <polygon points={`${xx},${xy} ${xx-8},${xy-3} ${xx-6},${xy+3}`} fill="#2E75B6"/>
        <text x={xx+8} y={xy+4} fontSize="17" fill="#2E75B6" fontWeight="700">x</text>
        <line x1={ox} y1={oy} x2={yx} y2={yy} stroke="#27ae60" strokeWidth="2.2"/>
        <polygon points={`${yx},${yy} ${yx-4},${yy+7} ${yx+4},${yy+6}`} fill="#27ae60"/>
        <text x={yx+4} y={yy-6} fontSize="17" fill="#27ae60" fontWeight="700">y</text>
        <line x1={ox} y1={oy} x2={zx} y2={zy} stroke="#c0392b" strokeWidth="2.2"/>
        <polygon points={`${zx},${zy} ${zx+8},${zy-3} ${zx+6},${zy+3}`} fill="#c0392b"/>
        <text x={zx+6} y={zy+4} fontSize="17" fill="#c0392b" fontWeight="700">z</text>
        <circle cx={ox} cy={oy} r={4} fill="#1F3864"/>
        <text x={ox-12} y={oy+14} fontSize="14" fill="#1F3864" fontWeight="700">O</text>
        {[1,2,3].map(v=>{
          const [ax2,ay2]=iso(v,0,0),[bx2,by2]=iso(0,v,0),[cx2,cy2]=iso(0,0,v);
          return <g key={v}>
            <circle cx={ax2} cy={ay2} r={2} fill="#2E75B6" opacity="0.5"/>
            <text x={ax2+5} y={ay2+14} fontSize="11" fill="#2E75B6" opacity="0.7">{v}</text>
            <circle cx={bx2} cy={by2} r={2} fill="#27ae60" opacity="0.5"/>
            <text x={bx2+5} y={by2+4} fontSize="11" fill="#27ae60" opacity="0.7">{v}</text>
            <circle cx={cx2} cy={cy2} r={2} fill="#c0392b" opacity="0.5"/>
            <text x={cx2-14} y={cy2+14} fontSize="11" fill="#c0392b" opacity="0.7">{v}</text>
          </g>;
        })}
        <line x1={ppx} y1={ppy} x2={fx} y2={fy} stroke="#9b59b6" strokeWidth="1.4" strokeDasharray="5,3"/>
        <line x1={ppx} y1={ppy} x2={lx} y2={ly} stroke="#e07b00" strokeWidth="1.4" strokeDasharray="5,3"/>
        <line x1={ppx} y1={ppy} x2={rx} y2={ry} stroke="#888" strokeWidth="1.2" strokeDasharray="5,3"/>
        <circle cx={ppx} cy={ppy} r={7} fill="#e07b00" stroke="#fff" strokeWidth="2"/>
        <text x={ppx+11} y={ppy-6} fontSize="15" fill="#e07b00" fontWeight="700">P(2,2,1.5)</text>
        <line x1={ox} y1={oy} x2={ppx-4} y2={ppy+3} stroke="#9b59b6" strokeWidth="1.8" strokeDasharray="7,3"/>
        <text x={(ox+ppx)/2-30} y={(oy+ppy)/2-8} fontSize="12" fill="#9b59b6" fontWeight="700">d=√(x²+y²+z²)</text>
        <rect x={px0} y={10} width={panW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={px0+panW/2} y={30} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Coordinate Essentials</text>
        {[
          {y:36,bg:"#EBF3FB",bc:"#2E75B6",title:"Right-Hand Rule",lines:["x: thumb →","y: index ↑","z: middle (toward you)"]},
          {y:118,bg:"#f0fff4",bc:"#27ae60",title:"Distance Formula",lines:["d = √((x₂-x₁)²","    + (y₂-y₁)²","    + (z₂-z₁)²)"]},
          {y:206,bg:"#fff7ee",bc:"#e07b00",title:"Midpoint Formula",lines:["M = ((x₁+x₂)/2,","     (y₁+y₂)/2,","     (z₁+z₂)/2)"]},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={title}>
            <rect x={px0+6} y={y} width={panW-12} height={74} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={px0+12} y={y+16} fontSize="13" fill="#1F3864" fontWeight="700">{title}</text>
            {lines.map((ln,i)=><text key={i} x={px0+12} y={y+31+i*17} fontSize="12" fill="#444" fontFamily="'Courier New',monospace">{ln}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>3D space uses three mutually perpendicular axes. The right-hand rule defines orientation. Every point P has three coordinates. Dashed lines show projections onto each coordinate plane.</div>
    </div>
  );
}

function DiagramLinesPlanesEq() {
  const W=900, H=320;
  const iso2=(x,y,z)=>[80+(x-z)*0.866*32, 190-y*32+(x+z)*0.5*32];
  const [o1x,o1y]=iso2(0,0,0),[x1x,x1y]=iso2(2.5,0,0),[y1x,y1y]=iso2(0,2.5,0),[z1x,z1y]=iso2(0,0,2.5);
  const L=(t)=>iso2(0.3+t,0.2+0.8*t,0.3+0.6*t);
  const [la1,la2]=L(-0.2),[lb1,lb2]=L(1.8),[pm1,pm2]=L(0.8),[dir1,dir2]=L(1.5);
  const plCorners=[[322,170],[482,130],[566,200],[406,240]];
  const cx2=(322+482+566+406)/4, cy2=(170+130+200+240)/4;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Lines and Planes — Equations, Normal Vectors, and Intersections</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <rect x={14} y={10} width={270} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={149} y={30} textAnchor="middle" fontSize="16" fill="#1F3864" fontWeight="700">Line in 3D</text>
        <text x={149} y={47} textAnchor="middle" fontSize="13" fill="#888">Parametric Form</text>
        <line x1={o1x} y1={o1y} x2={x1x} y2={x1y} stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={x1x+4} y={x1y+4} fontSize="12" fill="#2E75B6">x</text>
        <line x1={o1x} y1={o1y} x2={y1x} y2={y1y} stroke="#27ae60" strokeWidth="1.5"/>
        <text x={y1x+2} y={y1y-4} fontSize="12" fill="#27ae60">y</text>
        <line x1={o1x} y1={o1y} x2={z1x} y2={z1y} stroke="#c0392b" strokeWidth="1.5"/>
        <text x={z1x+4} y={z1y+4} fontSize="12" fill="#c0392b">z</text>
        <line x1={la1} y1={la2} x2={lb1} y2={lb2} stroke="#9b59b6" strokeWidth="2.5"/>
        <circle cx={pm1} cy={pm2} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
        <text x={pm1+8} y={pm2-4} fontSize="12" fill="#e07b00" fontWeight="700">P₀</text>
        <line x1={pm1} y1={pm2} x2={dir1-2} y2={dir2+2} stroke="#27ae60" strokeWidth="2"/>
        <polygon points={`${dir1},${dir2} ${dir1-7},${dir2-2} ${dir1-5},${dir2+4}`} fill="#27ae60"/>
        <text x={dir1+4} y={dir2-2} fontSize="12" fill="#27ae60" fontWeight="700">d</text>
        <rect x={22} y={222} width={252} height={60} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={28} y={238} fontSize="13" fill="#1F3864" fontWeight="700">Parametric equations:</text>
        <text x={28} y={254} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">r(t) = P₀ + t·d</text>
        <text x={28} y={270} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">x=x₀+at, y=y₀+bt, z=z₀+ct</text>
        <rect x={302} y={10} width={284} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={444} y={30} textAnchor="middle" fontSize="16" fill="#1F3864" fontWeight="700">Plane in 3D</text>
        <text x={444} y={47} textAnchor="middle" fontSize="13" fill="#888">Normal Vector Form</text>
        <polygon points={plCorners.map(p=>p.join(",")).join(" ")} fill="#d0e8ff" fillOpacity="0.7" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={cx2} y={cy2+6} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">plane</text>
        <line x1={cx2} y1={cy2} x2={cx2} y2={cy2-68} stroke="#c0392b" strokeWidth="2.5"/>
        <polygon points={`${cx2},${cy2-68} ${cx2-5},${cy2-56} ${cx2+5},${cy2-56}`} fill="#c0392b"/>
        <text x={cx2+7} y={cy2-55} fontSize="15" fill="#c0392b" fontWeight="700">n</text>
        <circle cx={cx2-38} cy={cy2+18} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
        <text x={cx2-30} y={cy2+14} fontSize="13" fill="#e07b00" fontWeight="700">P₀</text>
        <rect x={308} y={226} width={272} height={58} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={314} y={242} fontSize="13" fill="#1F3864" fontWeight="700">Plane equation:</text>
        <text x={314} y={258} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">n·(r - P₀) = 0</text>
        <text x={314} y={274} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">ax + by + cz = d</text>
        <rect x={600} y={10} width={288} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={744} y={30} textAnchor="middle" fontSize="16" fill="#1F3864" fontWeight="700">Intersection Types</text>
        <text x={744} y={47} textAnchor="middle" fontSize="13" fill="#888">Line vs Plane</text>
        {[
          {y:62,bg:"#f0fff4",bc:"#27ae60",label:"Line crosses plane",desc:"One intersection point",icon:"●",ic:"#e07b00"},
          {y:138,bg:"#EBF3FB",bc:"#2E75B6",label:"Line parallel to plane",desc:"Zero intersections",icon:"∥",ic:"#2E75B6"},
          {y:214,bg:"#fff7ee",bc:"#e07b00",label:"Line lies in plane",desc:"Infinite intersections",icon:"∞",ic:"#e07b00"},
        ].map(({y,bg,bc,label,desc,icon,ic})=>(
          <g key={label}>
            <rect x={606} y={y} width={276} height={64} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={636} y={y+38} textAnchor="middle" fontSize="28" fill={ic}>{icon}</text>
            <text x={658} y={y+28} fontSize="13" fill="#1F3864" fontWeight="700">{label}</text>
            <text x={658} y={y+46} fontSize="12" fill="#555">{desc}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>A line in 3D needs a point and direction vector. A plane needs a point and normal vector. Three possible outcomes when a line meets a plane: one point, no point, or the whole line.</div>
    </div>
  );
}

function DiagramSurfaces() {
  const W=900, H=330;
  const scx=151,scy=148,sr=86;
  const ccx=446,ctop=60,cbot=228,cr=76,cry=17;
  const ncx=746,nap=64,nbot=232,nr=78,nry=17;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Common 3D Surfaces — Sphere, Cylinder, Cone, and Their Equations</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <rect x={14} y={10} width={274} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={151} y={28} textAnchor="middle" fontSize="16" fill="#1F3864" fontWeight="700">Sphere</text>
        <ellipse cx={scx+6} cy={scy+sr+10} rx={sr*0.7} ry={10} fill="#bbb" opacity="0.3"/>
        <circle cx={scx} cy={scy} r={sr} fill="#d0e8ff" stroke="#2E75B6" strokeWidth="2"/>
        <ellipse cx={scx} cy={scy} rx={sr} ry={sr*0.28} fill="none" stroke="#2E75B6" strokeWidth="1.2" strokeDasharray="5,3"/>
        <ellipse cx={scx} cy={scy} rx={sr*0.28} ry={sr} fill="none" stroke="#2E75B6" strokeWidth="1.2" strokeDasharray="5,3"/>
        <line x1={scx} y1={scy} x2={scx+sr*0.707} y2={scy-sr*0.707} stroke="#c0392b" strokeWidth="2"/>
        <circle cx={scx} cy={scy} r={4} fill="#c0392b"/>
        <text x={scx+sr*0.36} y={scy-sr*0.36-5} fontSize="14" fill="#c0392b" fontWeight="700">r</text>
        <text x={scx+4} y={scy+14} fontSize="13" fill="#1F3864" fontWeight="700">(h,k,l)</text>
        <rect x={20} y={254} width={262} height={56} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={270} fontSize="13" fill="#1F3864" fontWeight="700">Standard form:</text>
        <text x={26} y={286} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">(x-h)²+(y-k)²+(z-l)²=r²</text>
        <text x={26} y={300} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">Center (h,k,l),  radius r</text>
        <rect x={306} y={10} width={280} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={446} y={28} textAnchor="middle" fontSize="16" fill="#1F3864" fontWeight="700">Cylinder</text>
        <ellipse cx={ccx+5} cy={cbot+12} rx={cr*0.7} ry={8} fill="#bbb" opacity="0.3"/>
        <rect x={ccx-cr} y={ctop} width={cr*2} height={cbot-ctop} fill="#d0e8ff"/>
        <line x1={ccx-cr} y1={ctop} x2={ccx-cr} y2={cbot} stroke="#2E75B6" strokeWidth="2"/>
        <line x1={ccx+cr} y1={ctop} x2={ccx+cr} y2={cbot} stroke="#2E75B6" strokeWidth="2"/>
        <ellipse cx={ccx} cy={ctop} rx={cr} ry={cry} fill="#b8d8f8" stroke="#2E75B6" strokeWidth="2"/>
        <ellipse cx={ccx} cy={cbot} rx={cr} ry={cry} fill="#d0e8ff" stroke="#2E75B6" strokeWidth="2"/>
        <line x1={ccx} y1={ctop} x2={ccx+cr-2} y2={ctop} stroke="#c0392b" strokeWidth="2"/>
        <text x={ccx+cr/2-4} y={ctop-7} fontSize="14" fill="#c0392b" fontWeight="700">r</text>
        <line x1={ccx+cr+14} y1={ctop} x2={ccx+cr+14} y2={cbot} stroke="#27ae60" strokeWidth="2"/>
        <line x1={ccx+cr+8} y1={ctop} x2={ccx+cr+20} y2={ctop} stroke="#27ae60" strokeWidth="1.5"/>
        <line x1={ccx+cr+8} y1={cbot} x2={ccx+cr+20} y2={cbot} stroke="#27ae60" strokeWidth="1.5"/>
        <text x={ccx+cr+22} y={(ctop+cbot)/2+5} fontSize="14" fill="#27ae60" fontWeight="700">h</text>
        <rect x={312} y={254} width={268} height={56} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={318} y={270} fontSize="13" fill="#1F3864" fontWeight="700">Circular cylinder (axis z):</text>
        <text x={318} y={286} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">x² + y² = r²</text>
        <text x={318} y={300} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">V = πr²h,  SA = 2πr(r+h)</text>
        <rect x={604} y={10} width={284} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={746} y={28} textAnchor="middle" fontSize="16" fill="#1F3864" fontWeight="700">Cone</text>
        <ellipse cx={ncx+5} cy={nbot+12} rx={nr*0.65} ry={8} fill="#bbb" opacity="0.3"/>
        <polygon points={`${ncx},${nap} ${ncx-nr},${nbot} ${ncx+nr},${nbot}`} fill="#d0e8ff"/>
        <line x1={ncx} y1={nap} x2={ncx-nr} y2={nbot} stroke="#2E75B6" strokeWidth="2"/>
        <line x1={ncx} y1={nap} x2={ncx+nr} y2={nbot} stroke="#2E75B6" strokeWidth="2"/>
        <ellipse cx={ncx} cy={nbot} rx={nr} ry={nry} fill="#d0e8ff" stroke="#2E75B6" strokeWidth="2"/>
        <circle cx={ncx} cy={nap} r={4} fill="#c0392b"/>
        <line x1={ncx} y1={nap} x2={ncx} y2={nbot} stroke="#9b59b6" strokeWidth="1.5" strokeDasharray="5,3"/>
        <text x={ncx+6} y={(nap+nbot)/2} fontSize="14" fill="#9b59b6" fontWeight="700">h</text>
        <line x1={ncx} y1={nbot} x2={ncx+nr-2} y2={nbot} stroke="#c0392b" strokeWidth="2"/>
        <text x={ncx+nr/2-5} y={nbot+16} fontSize="14" fill="#c0392b" fontWeight="700">r</text>
        <line x1={ncx} y1={nap} x2={ncx+nr} y2={nbot} stroke="#e07b00" strokeWidth="1.8"/>
        <text x={ncx+nr/2+16} y={(nap+nbot)/2-10} fontSize="13" fill="#e07b00" fontWeight="700">l</text>
        <rect x={610} y={254} width={272} height={56} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={616} y={270} fontSize="13" fill="#1F3864" fontWeight="700">Circular cone:</text>
        <text x={616} y={286} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">x²+y² = (r/h)²z²</text>
        <text x={616} y={300} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">V = ⅓πr²h,  l = √(r²+h²)</text>
      </svg>
      <div style={S.dCaption}>A sphere is all points equidistant from a center. A cylinder extends a circle along an axis. A cone is generated by rotating a line about an axis through a fixed apex point.</div>
    </div>
  );
}

function DiagramVolumes() {
  const W=900, H=320;
  const iso=(x,y,z,ox,oy,sc)=>[ox+(x-z)*0.866*sc, oy-y*sc+(x+z)*0.5*sc];
  const cv=(x,y,z)=>iso(x,y,z,75,165,36);
  const s=2;
  const cverts=[cv(0,0,0),cv(s,0,0),cv(s,0,s),cv(0,0,s),cv(0,s,0),cv(s,s,0),cv(s,s,s),cv(0,s,s)];
  const edges=[[0,1],[1,2],[2,3],[3,0],[4,5],[5,6],[6,7],[7,4],[0,4],[1,5],[2,6],[3,7]];
  const cdash=new Set([2,3,11]);
  const bv=(x,y,z)=>iso(x,y,z,275,165,34);
  const bverts=[bv(0,0,0),bv(3,0,0),bv(3,0,1.5),bv(0,0,1.5),bv(0,1.5,0),bv(3,1.5,0),bv(3,1.5,1.5),bv(0,1.5,1.5)];
  const bdash=new Set([2,3,11]);
  const pv=(x,y,z)=>iso(x,y,z,490,200,36);
  const ps=2.4,ph=2.4;
  const pbase=[pv(0,0,0),pv(ps,0,0),pv(ps,0,ps),pv(0,0,ps)];
  const papex=pv(ps/2,ph,ps/2), pbc=pv(ps/2,0,ps/2);
  const tv=(x,y,z)=>iso(x,y,z,710,200,38);
  const ta=2.6;
  const [v0,v1,v2,v3]=[tv(0,0,0),tv(ta,0,0),tv(ta/2,0,ta*0.866),tv(ta/2,ta*0.816,ta*0.289)];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>3D Solids — Cube, Rectangular Prism, Square Pyramid, and Tetrahedron</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <rect x={14} y={10} width={208} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={118} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Cube</text>
        <polygon points={[cverts[4],cverts[5],cverts[6],cverts[7]].map(p=>p.join(",")).join(" ")} fill="#d0e8ff" fillOpacity="0.7"/>
        <polygon points={[cverts[1],cverts[5],cverts[6],cverts[2]].map(p=>p.join(",")).join(" ")} fill="#b8d8f8" fillOpacity="0.7"/>
        {edges.map((e,i)=><line key={i} x1={cverts[e[0]][0]} y1={cverts[e[0]][1]} x2={cverts[e[1]][0]} y2={cverts[e[1]][1]} stroke="#2E75B6" strokeWidth="2" strokeDasharray={cdash.has(i)?"4,3":""} opacity={cdash.has(i)?0.4:1}/>)}
        <text x={(cverts[0][0]+cverts[1][0])/2} y={(cverts[0][1]+cverts[1][1])/2+14} fontSize="13" fill="#c0392b" fontWeight="700">a</text>
        <rect x={20} y={242} width={196} height={60} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={258} fontSize="12" fill="#1F3864" fontWeight="700">Cube (side a):</text>
        <text x={26} y={273} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">V = a³,  SA = 6a²</text>
        <text x={26} y={288} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">diagonal = a√3</text>
        <rect x={234} y={10} width={210} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={339} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Rectangular Prism</text>
        <polygon points={[bverts[4],bverts[5],bverts[6],bverts[7]].map(p=>p.join(",")).join(" ")} fill="#d0e8ff" fillOpacity="0.7"/>
        <polygon points={[bverts[1],bverts[5],bverts[6],bverts[2]].map(p=>p.join(",")).join(" ")} fill="#b8d8f8" fillOpacity="0.7"/>
        {edges.map((e,i)=><line key={i} x1={bverts[e[0]][0]} y1={bverts[e[0]][1]} x2={bverts[e[1]][0]} y2={bverts[e[1]][1]} stroke="#27ae60" strokeWidth="2" strokeDasharray={bdash.has(i)?"4,3":""} opacity={bdash.has(i)?0.4:1}/>)}
        <text x={(bverts[0][0]+bverts[1][0])/2-4} y={(bverts[0][1]+bverts[1][1])/2+14} fontSize="13" fill="#c0392b" fontWeight="700">l</text>
        <text x={(bverts[1][0]+bverts[5][0])/2+4} y={(bverts[1][1]+bverts[5][1])/2} fontSize="13" fill="#27ae60" fontWeight="700">h</text>
        <text x={(bverts[2][0]+bverts[1][0])/2+8} y={(bverts[2][1]+bverts[1][1])/2+4} fontSize="13" fill="#9b59b6" fontWeight="700">w</text>
        <rect x={240} y={242} width={198} height={60} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={246} y={258} fontSize="12" fill="#1F3864" fontWeight="700">Box (l×w×h):</text>
        <text x={246} y={273} fontSize="12" fill="#27ae60" fontFamily="'Courier New',monospace">V = l·w·h</text>
        <text x={246} y={288} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">SA = 2(lw+lh+wh)</text>
        <rect x={456} y={10} width={210} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={561} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Square Pyramid</text>
        <polygon points={pbase.map(p=>p.join(",")).join(" ")} fill="#d0e8ff" fillOpacity="0.6" stroke="#9b59b6" strokeWidth="1.8"/>
        {pbase.map((pt,i)=><line key={i} x1={pt[0]} y1={pt[1]} x2={papex[0]} y2={papex[1]} stroke="#9b59b6" strokeWidth={i>=2?1.5:2} strokeDasharray={i>=2?"4,3":""} opacity={i>=2?0.5:1}/>)}
        <circle cx={papex[0]} cy={papex[1]} r={4} fill="#e07b00"/>
        <line x1={papex[0]} y1={papex[1]} x2={pbc[0]} y2={pbc[1]} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="4,3"/>
        <text x={papex[0]+6} y={(papex[1]+pbc[1])/2} fontSize="13" fill="#e07b00" fontWeight="700">h</text>
        <text x={(pbase[0][0]+pbase[1][0])/2-4} y={(pbase[0][1]+pbase[1][1])/2+14} fontSize="13" fill="#9b59b6" fontWeight="700">a</text>
        <rect x={462} y={242} width={198} height={60} rx={3} fill="#fff7ee" stroke="#9b59b6" strokeWidth="1"/>
        <text x={468} y={258} fontSize="12" fill="#1F3864" fontWeight="700">Sq. pyramid (base a, ht h):</text>
        <text x={468} y={273} fontSize="12" fill="#9b59b6" fontFamily="'Courier New',monospace">V = ⅓a²h</text>
        <text x={468} y={288} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">SA = a²+2a·l (l=slant)</text>
        <rect x={678} y={10} width={210} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={783} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Tetrahedron</text>
        <polygon points={[v0,v1,v2].map(p=>p.join(",")).join(" ")} fill="#d0e8ff" fillOpacity="0.5" stroke="#c0392b" strokeWidth="1.5"/>
        <polygon points={[v0,v1,v3].map(p=>p.join(",")).join(" ")} fill="#b8d8f8" fillOpacity="0.7" stroke="#c0392b" strokeWidth="1.8"/>
        <polygon points={[v1,v2,v3].map(p=>p.join(",")).join(" ")} fill="#d8eeff" fillOpacity="0.6" stroke="#c0392b" strokeWidth="1.8"/>
        <line x1={v0[0]} y1={v0[1]} x2={v2[0]} y2={v2[1]} stroke="#c0392b" strokeWidth="1.2" strokeDasharray="4,3" opacity="0.5"/>
        <line x1={v2[0]} y1={v2[1]} x2={v3[0]} y2={v3[1]} stroke="#c0392b" strokeWidth="1.8"/>
        <line x1={v0[0]} y1={v0[1]} x2={v3[0]} y2={v3[1]} stroke="#c0392b" strokeWidth="1.8"/>
        <text x={(v0[0]+v1[0])/2-4} y={(v0[1]+v1[1])/2+14} fontSize="13" fill="#e07b00" fontWeight="700">a</text>
        <rect x={684} y={242} width={198} height={60} rx={3} fill="#EBF3FB" stroke="#c0392b" strokeWidth="1"/>
        <text x={690} y={258} fontSize="12" fill="#1F3864" fontWeight="700">Regular tetrahedron (edge a):</text>
        <text x={690} y={273} fontSize="12" fill="#c0392b" fontFamily="'Courier New',monospace">V = a³/(6√2)</text>
        <text x={690} y={288} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">SA = √3·a²</text>
      </svg>
      <div style={S.dCaption}>Four fundamental polyhedra in isometric projection. Cube and prism: 6 faces, 12 edges, 8 vertices. Square pyramid: 5 faces, 8 edges, 5 vertices. Tetrahedron: 4 equilateral triangular faces.</div>
    </div>
  );
}

function DiagramDistanceAngles() {
  const W=900, H=300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Distances, Angles, and Cross-Sections in 3D</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <rect x={14} y={10} width={270} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={149} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Point-to-Plane Distance</text>
        <polygon points="30,178 200,148 250,218 80,248" fill="#d0e8ff" fillOpacity="0.7" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={140} y={213} fontSize="12" fill="#2E75B6">ax+by+cz=d</text>
        <line x1={145} y1={176} x2={145} y2={100} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4,3" opacity="0.5"/>
        <text x={150} y={132} fontSize="12" fill="#2E75B6" fontWeight="700">n̂</text>
        <circle cx={155} cy={60} r={6} fill="#e07b00" stroke="#fff" strokeWidth="2"/>
        <text x={165} y={56} fontSize="13" fill="#e07b00" fontWeight="700">P</text>
        <line x1={155} y1={60} x2={145} y2={176} stroke="#c0392b" strokeWidth="2.2"/>
        <text x={163} y={122} fontSize="13" fill="#c0392b" fontWeight="700">d</text>
        <rect x={20} y={228} width={258} height={52} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={244} fontSize="12" fill="#1F3864" fontWeight="700">Distance P to plane ax+by+cz=d:</text>
        <text x={26} y={260} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">dist = |ax₀+by₀+cz₀-d|</text>
        <text x={26} y={274} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">       / √(a²+b²+c²)</text>
        <rect x={302} y={10} width={280} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={442} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Dihedral Angle</text>
        <text x={442} y={44} textAnchor="middle" fontSize="13" fill="#888">Angle between two planes</text>
        <polygon points="310,220 410,180 530,100 540,200 330,250" fill="#d0e8ff" fillOpacity="0.5" stroke="#2E75B6" strokeWidth="1.5"/>
        <polygon points="310,220 420,250 575,232 530,100" fill="#d0f0d8" fillOpacity="0.5" stroke="#27ae60" strokeWidth="1.5"/>
        <line x1={310} y1={220} x2={530} y2={100} stroke="#9b59b6" strokeWidth="2.5"/>
        <text x={534} y={96} fontSize="12" fill="#9b59b6" fontWeight="700">hinge</text>
        <line x1={420} y1={183} x2={382} y2={120} stroke="#2E75B6" strokeWidth="2"/>
        <polygon points="382,120 390,128 376,128" fill="#2E75B6"/>
        <text x={370} y={112} fontSize="14" fill="#2E75B6" fontWeight="700">n₁</text>
        <line x1={440} y1={218} x2={478} y2={158} stroke="#27ae60" strokeWidth="2"/>
        <polygon points="478,158 470,166 484,168" fill="#27ae60"/>
        <text x={482} y={153} fontSize="14" fill="#27ae60" fontWeight="700">n₂</text>
        <path d="M 400,132 A 28 28 0 0 1 468,162" fill="none" stroke="#c0392b" strokeWidth="1.8"/>
        <text x={426} y={140} fontSize="14" fill="#c0392b" fontWeight="700">θ</text>
        <rect x={308} y={230} width={268} height={50} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={314} y={246} fontSize="12" fill="#1F3864" fontWeight="700">Angle between planes:</text>
        <text x={314} y={262} fontSize="12" fill="#27ae60" fontFamily="'Courier New',monospace">cos θ = |n₁·n₂| / (|n₁||n₂|)</text>
        <text x={314} y={275} fontSize="11" fill="#555">n₁, n₂ are the plane normal vectors</text>
        <rect x={600} y={10} width={288} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={744} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Cone Cross Sections</text>
        <text x={744} y={44} textAnchor="middle" fontSize="13" fill="#888">Conic sections</text>
        {[
          {label:"Circle",fill:"#d0e8ff",bc:"#2E75B6",y:56,desc:"Plane ⊥ to axis"},
          {label:"Ellipse",fill:"#d0f0d8",bc:"#27ae60",y:113,desc:"Plane tilted slightly"},
          {label:"Parabola",fill:"#fff0cc",bc:"#e07b00",y:170,desc:"Plane ∥ to one side"},
          {label:"Hyperbola",fill:"#f5d0ff",bc:"#9b59b6",y:227,desc:"Plane cuts both nappes"},
        ].map(({label,fill,bc,y,desc})=>(
          <g key={label}>
            <rect x={606} y={y} width={276} height={46} rx={3} fill={fill} stroke={bc} strokeWidth="1"/>
            <text x={616} y={y+16} fontSize="14" fill="#1F3864" fontWeight="700">{label}</text>
            <text x={616} y={y+32} fontSize="12" fill="#555">{desc}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Point-to-plane distance uses the normal vector for the shortest path. The dihedral angle is found from the dot product of the two plane normals. Slicing a cone at different angles yields the four conic sections.</div>
    </div>
  );
}

function DiagramEuler() {
  const W=900, H=290;
  const solids=[
    {name:"Tetrahedron",V:4,E:6,F:4,color:"#c0392b",fill:"#fde8e8",x:20,face:"triangles",fpv:"3",dual:"itself"},
    {name:"Cube",V:8,E:12,F:6,color:"#2E75B6",fill:"#d0e8ff",x:196,face:"squares",fpv:"3",dual:"octahedron"},
    {name:"Octahedron",V:6,E:12,F:8,color:"#27ae60",fill:"#d0f0d8",x:372,face:"triangles",fpv:"4",dual:"cube"},
    {name:"Dodecahedron",V:20,E:30,F:12,color:"#9b59b6",fill:"#f5d0ff",x:548,face:"pentagons",fpv:"3",dual:"icosahedron"},
    {name:"Icosahedron",V:12,E:30,F:20,color:"#e07b00",fill:"#fff0cc",x:724,face:"triangles",fpv:"5",dual:"dodecahed."},
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Euler's Polyhedron Formula — V − E + F = 2 for All Convex Polyhedra</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <rect x={14} y={10} width={W-28} height={52} rx={6} fill="#1F3864"/>
        <text x={W/2} y={33} textAnchor="middle" fontSize="21" fill="#fff" fontWeight="700" letterSpacing="2">V − E + F = 2</text>
        <text x={W/2} y={52} textAnchor="middle" fontSize="13" fill="#aac8e8">Vertices − Edges + Faces = 2  (Euler's formula for all convex polyhedra)</text>
        {solids.map(({name,V,E,F,color,fill,x,face,fpv,dual})=>(
          <g key={name}>
            <rect x={x} y={72} width={162} height={200} rx={5} fill={fill} stroke={color} strokeWidth="1.5"/>
            <text x={x+81} y={90} textAnchor="middle" fontSize="13" fill={color} fontWeight="700">{name}</text>
            {[["V",V],["E",E],["F",F]].map(([lbl,val],i)=>(
              <g key={lbl}>
                <rect x={x+8+i*50} y={97} width={44} height={44} rx={3} fill="#fff" stroke={color} strokeWidth="1"/>
                <text x={x+30+i*50} y={115} textAnchor="middle" fontSize="12" fill="#555" fontWeight="700">{lbl}</text>
                <text x={x+30+i*50} y={133} textAnchor="middle" fontSize="16" fill={color} fontWeight="700">{val}</text>
              </g>
            ))}
            <text x={x+81} y={158} textAnchor="middle" fontSize="12" fill="#555" fontFamily="'Courier New',monospace">{V}−{E}+{F}={V-E+F}</text>
            <rect x={x+8} y={165} width={146} height={96} rx={3} fill="#fff" stroke={color} strokeWidth="0.8"/>
            {[["Faces:",face],["Per vtx:",fpv],["Dual:",dual]].map(([lbl,val],i)=>(
              <g key={lbl}>
                <text x={x+14} y={182+i*28} fontSize="10" fill="#888">{lbl}</text>
                <text x={x+14} y={196+i*28} fontSize="12" fill={color} fontWeight="700">{val}</text>
              </g>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Euler's formula V − E + F = 2 holds for every convex polyhedron. The five Platonic solids are the only regular convex polyhedra. Dual pairs: cube↔octahedron, dodecahedron↔icosahedron; tetrahedron is self-dual.</div>
    </div>
  );
}

export default function Geometry3D() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>3D Geometry</h1>
      <p style={S.p}>Three-dimensional geometry extends points, lines, and shapes into a third spatial dimension. Every physical structure, engineering design, and scientific model lives in 3D space. Understanding how to describe positions, distances, angles, surfaces, and volumes in three dimensions is essential across mathematics, physics, computer graphics, and engineering.</p>
      <InfoBox title="The Three Axes:  x (left-right),  y (up-down),  z (in-out)" items={[
        "Right-hand rule: fingers curl from x toward y, thumb points in z — defines positive orientation",
        "Every point P in 3D space is uniquely described by an ordered triple (x, y, z)",
        "Distance from origin: |OP| = √(x² + y² + z²) — the 3D Pythagorean theorem",
        "Three coordinate planes: xy (z=0), xz (y=0), yz (x=0) — divide space into 8 octants",
      ]}/>
      <h2 style={S.h2}>3D Coordinate System and Points</h2>
      <DiagramCoordinates/>
      <Table2 rows={[
        ["Distance formula","d(P,Q) = √((x₂-x₁)² + (y₂-y₁)² + (z₂-z₁)²)\nDirect 3D extension of the Pythagorean theorem"],
        ["Midpoint formula","M = ((x₁+x₂)/2, (y₁+y₂)/2, (z₁+z₂)/2)\nMidpoint of segment PQ"],
        ["Direction cosines","cos α = x/|r|,  cos β = y/|r|,  cos γ = z/|r|\nAngles a vector makes with each axis; cos²α+cos²β+cos²γ=1"],
        ["Coordinate planes","xy-plane: z=0,  xz-plane: y=0,  yz-plane: x=0\nProjections onto each plane drop the third coordinate"],
        ["Octants","8 regions defined by sign of each coordinate\nOctant I: all positive (+,+,+)"],
      ]}/>
      <h2 style={S.h2}>Lines and Planes in 3D</h2>
      <DiagramLinesPlanesEq/>
      <Table2 rows={[
        ["Line — parametric","r(t) = P₀ + t·d = (x₀+at, y₀+bt, z₀+ct)\nP₀ is a point on the line, d=(a,b,c) is the direction vector"],
        ["Line — symmetric","(x-x₀)/a = (y-y₀)/b = (z-z₀)/c\nEquivalent form; undefined when any denominator is zero"],
        ["Plane — normal form","n·(r - P₀) = 0  where n is the normal vector\nAll points r in the plane satisfy this dot product"],
        ["Plane — general","ax + by + cz = d\nCoefficients (a,b,c) are components of normal vector n"],
        ["Normal from two vectors","n = v₁ × v₂\nCross product of two direction vectors lying in the plane"],
        ["Plane through 3 points","v₁=B−A,  v₂=C−A,  n=v₁×v₂,  then n·(r−A)=0"],
        ["Line-plane angle","sin θ = |d·n| / (|d||n|)\nd is line direction, n is plane normal"],
        ["Plane-plane angle","cos θ = |n₁·n₂| / (|n₁||n₂|)\nAngle between normals equals the dihedral angle"],
      ]}/>
      <h2 style={S.h2}>Common Surfaces and Their Equations</h2>
      <DiagramSurfaces/>
      <Table2 rows={[
        ["Sphere","(x-h)²+(y-k)²+(z-l)²=r²\nCenter (h,k,l), radius r; all points equidistant from center"],
        ["Cylinder (z-axis)","x²+y²=r²  (no z term — extends infinitely along z)\nFor finite cylinder: add constraint 0 ≤ z ≤ h"],
        ["Cone","x²/a² + y²/b² = z²/c²  (apex at origin)\nCircular cone when a=b; opens along z-axis"],
        ["Ellipsoid","x²/a² + y²/b² + z²/c² = 1\nSphere when a=b=c=r"],
        ["Elliptic paraboloid","z = x²/a² + y²/b²\nOpens upward; cross-sections parallel to xy-plane are ellipses"],
        ["Hyperbolic paraboloid","z = x²/a² − y²/b²  (saddle surface)\nCross-sections are parabolas; characteristic saddle shape"],
      ]}/>
      <h2 style={S.h2}>Volumes and Surface Areas of 3D Solids</h2>
      <DiagramVolumes/>
      <Table2 rows={[
        ["Cube (side a)","V = a³,  SA = 6a²,  space diagonal = a√3"],
        ["Rectangular box (l,w,h)","V = l·w·h\nSA = 2(lw+lh+wh),  diagonal = √(l²+w²+h²)"],
        ["Sphere (radius r)","V = (4/3)πr³\nSA = 4πr²"],
        ["Cylinder (r,h)","V = πr²h\nLateral SA = 2πrh,  Total SA = 2πr(r+h)"],
        ["Cone (r,h)","V = (1/3)πr²h\nLateral SA = πrl  where slant l = √(r²+h²)"],
        ["Pyramid (base B, height h)","V = (1/3)·B·h  (B = base area, any polygon)\nSA = B + (1/2)·perimeter·slant height"],
        ["Tetrahedron (edge a)","V = a³/(6√2)\nSA = √3·a²"],
      ]}/>
      <h2 style={S.h2}>Distances, Angles, and Cross-Sections</h2>
      <DiagramDistanceAngles/>
      <Table2 rows={[
        ["Point-to-plane","d = |ax₀+by₀+cz₀−D| / √(a²+b²+c²)\nPlane: ax+by+cz=D,  Point: (x₀,y₀,z₀)"],
        ["Point-to-line","d = |AP × d̂|  where A is any point on line, d̂ is unit direction\nLength of AP component perpendicular to the line"],
        ["Skew line distance","d = |(P₂−P₁)·(d₁×d₂)| / |d₁×d₂|\nOnly for lines that neither intersect nor are parallel"],
        ["Dihedral angle","cos θ = |n₁·n₂| / (|n₁||n₂|)\nAngle along the hinge line between two half-planes"],
        ["Conic sections","Circle: plane ⊥ to axis\nEllipse: plane cuts at angle\nParabola: plane ∥ to one side\nHyperbola: plane cuts both nappes"],
      ]}/>
      <h2 style={S.h2}>Euler's Formula and the Platonic Solids</h2>
      <DiagramEuler/>
      <Table2 rows={[
        ["Euler's formula","V − E + F = 2  for any convex polyhedron\nExample: cube 8−12+6=2 ✓,  tetrahedron 4−6+4=2 ✓"],
        ["Tetrahedron","4 vertices, 6 edges, 4 triangular faces — self-dual"],
        ["Cube / Hexahedron","8 vertices, 12 edges, 6 square faces — dual: octahedron"],
        ["Octahedron","6 vertices, 12 edges, 8 triangular faces — dual: cube"],
        ["Dodecahedron","20 vertices, 30 edges, 12 pentagonal faces — dual: icosahedron"],
        ["Icosahedron","12 vertices, 30 edges, 20 triangular faces — dual: dodecahedron"],
        ["Generalised Euler","V − E + F = 2 − 2g  (g = genus, number of holes)\nA torus (g=1) gives V−E+F=0"],
      ]}/>
      <InfoBox title="Key Takeaway — What Formula to Use When in 3D Geometry" items={[
        "Distance between two points? → d = √((Δx)²+(Δy)²+(Δz)²)",
        "Equation of plane through point P₀ with normal n? → n·(r−P₀) = 0",
        "Angle between two planes or vectors? → cos θ = (a·b)/(|a||b|)",
        "Normal to a plane from two in-plane vectors? → n = v₁ × v₂",
        "Volume of any pyramid or cone? → V = ⅓ × (base area) × height",
        "Verify or count faces of a polyhedron? → Euler: V − E + F = 2",
        "Recognise a surface from its equation? → Memorise: sphere, cylinder, cone, ellipsoid, paraboloid",
      ]}/>
    </div>
  );
}